import 'jquery';
import {plenigoLog} from './logger';

/**
 * see https://stripe.com/docs/testing
 *
 *
 */

(function ($, Stripe) {
  var form = $('form[data-submit="stripe"]');

  if (!form.length) {
    return;
  }

  if (typeof Stripe === 'undefined') {
    plenigoLog.error('Cant load Stripe JS');
    return;
  }

  let stripeCardStyle;
  if (typeof window.stripeCardStyle !== 'undefined') {
    stripeCardStyle = window.stripeCardStyle;
  } else {
    stripeCardStyle = {
      base: {
        color: '#000',
        fontSize: '14px',
        fontWeight: 500,
        '::placeholder': {
          color: '#7d7d7d',
        },
      },
    };
  }

  let owner = form.data('config'),
    submit = form.find(':submit'),
    paymentMethodId = form.find('#stripe_creditcard_form_payment_method'),
    paymentFormErrorMsg = form.find('#stripe_creditcard_form_errorMsg'),
    statusField = $('#stripeStatusField'),
    // connected account
    accountId = ((typeof owner.accountId == 'string' && owner.accountId) ? owner.accountId : null),
    stripeConfig = {
      locale: form.data('language'),
    },
    // will be initialized later
    stripe,
    elements,
    cardElement,
    options = {
      // Custom styling can be passed to options when creating an Element
      style: stripeCardStyle,
    };

  // https://stripe.com/docs/js/initializing#init_stripe_js-options
  // this should be a connected account
  if (accountId) {
    stripeConfig['stripeAccount'] = accountId;
  }
  // initialize stripe
  stripe = Stripe(owner.publicKey, stripeConfig);
  elements = stripe.elements();
  // we can prefill it a bit:
  //https://stripe.com/docs/js/elements_object/create_element?type=card#elements_create-options-value
  cardElement = elements ? elements.create('card', options) : null;

  // disable submit (if isnt)
  submit.prop('disabled', true);

  /**
   *
   * handling events of stripe element
   * https://stripe.com/docs/js/element/events/on_change?type=cardElement#element_on_change-handler
   *
   */
  cardElement.on('change', function (event) {
    if (event.complete) {
      statusField.val('full');
      // unlockSubmit();
      submit.focus();
    } else if (event.error) {
      // show validation to customer
    } else {
      // lockSubmit();
      statusField.val('');
    }
    statusField.trigger('change');
  });

  /**
   *
   * https://stripe.com/docs/js/element/events/on_ready
   */
  cardElement.on('ready', function () {
    // resize iframe
    $(document).trigger('resize').trigger('plenigo.resize');
    submit.prop('disabled', true);
  });


  /**
   *
   * the whole magic is put in the submit event
   */
  form.on('submit', function (e) {
    var cardholderName = $('#stripe_creditcard_form_owner').val();

    if (cardholderName.length < 3) {
      return true;
    }

    if (paymentMethodId.val().length > 4) {
      return true;
    }

    // 1st remove all error messages
    form.find('#errorMessage').removeClass('has_errors');

    // prevent our form from being submitted
    e.preventDefault();

    form.data('processing', true);

    stripe.confirmCardSetup(
      owner.clientSecret,
      {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: cardholderName,
          },
        },
      }
    ).then(function (result) {
      if (result.error) {
        // Display error.message in your UI.
        paymentFormErrorMsg.val(result.error.message);
        paymentMethodId.val('ERROR');
      } else {
        paymentMethodId.val(result.setupIntent.payment_method);
        // The setup has succeeded. Display a success message.
      }
      form.data('processing', false);
      form.submit();
    });
  });

  // start
  cardElement.mount('#stripeCardElement');

}(jQuery, window.Stripe));
